import React, {useRef, useState} from 'react';
import HeroPicture from './AlpiHeroPicture.jsx';
import Landmark from '@core/scripts/components/landmark-adapter';
import {Constants} from '../view-constants';
import {Carousel} from '@bonprix/design-system';
import Device from '@core/scripts/components/device.js';

function HeroPictureSlider({
    url,
    images,
    inView,
    isShopContent,
    heroPictureOnClick,
    positionIndex,
    onImageLoaded,
    isImageLoaded,
    heroPictureOnAuxClick,
    heroPictureOnContextMenu,
}) {
    const [slideIndex, setSlideIndex] = useState(0);
    const [showArrows, setShowArrows] = useState(false);

    const onClick = (e, image) => {
        return heroPictureOnClick(e, url, image.id);
    };
    const onAuxClick = (e, linkTag, image) => {
        return heroPictureOnAuxClick(e, linkTag, url, image.id);
    };
    const onContextMenu = (linkTag, image) => {
        return heroPictureOnContextMenu(linkTag, url, image.id);
    };

    const onMove = (next, prev) => {
        setSlideIndex(next);
        sendLandmark();
    };

    const handleImageLoaded = () => {
        onImageLoaded();
    };

    function sendLandmark() {
        const pageType = isShopContent ? Constants.LANDMARK_PAGETYPE_AOP : Constants.LANDMARK_PAGETYPE_SRP;
        const lmValue = `${pageType}\\${Constants.LANDMARK_PICSLIDE}`;

        Landmark.sendLandmark({
            landmark: 'userinterface',
            click: lmValue,
        });
    }

    const handleMouseEnter = () => {
        if (!Device.isTouch()) {
            setShowArrows(true);
        }
    };
    const handleMouseLeave = () => {
        if (!Device.isTouch()) {
            setShowArrows(false);
        }
    };

    const sliderHook = `jsh-alpi-slider-anchor-${positionIndex}`;
    const attributes = {[sliderHook]: ''};

    return (
        <div {...attributes} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <Carousel
                label={'Produktbilder'}
                arrows={isImageLoaded && showArrows}
                onMove={onMove}
                rewind={true}
                pagination={isImageLoaded}
            >
                {images.map((image, index) => (
                    <Carousel.Slide key={index}>
                        <HeroPicture
                            key={image.url}
                            url={url}
                            image={image}
                            positionIndex={positionIndex}
                            inView={inView && image === images[slideIndex]}
                            heroPictureOnClick={(e) => onClick(e, image)}
                            heroPictureOnAuxClick={(e, linkTag) => onAuxClick(e, linkTag, image)}
                            heroPictureOnContextMenu={(linkTag) => onContextMenu(linkTag, image)}
                            onLoad={handleImageLoaded}
                        />
                    </Carousel.Slide>
                ))}
            </Carousel>
        </div>
    );
}

export default React.memo(HeroPictureSlider);
